module.exports = __webpack_public_path__ + "static/media/img-114.b9b887cc.jpg";